import { Flex, Form, Input, Radio } from "antd";

export default function RenderRadio(props) {
	const { namePath = [], form_question_options = [], required = false } = props;

	let newNamePath = Array.isArray(namePath) ? namePath.join("_") : namePath;

	return (
		<Form.Item shouldUpdate noStyle>
			{({ getFieldValue }) => {
				let selectedValue = getFieldValue(newNamePath);
				let findOther = form_question_options.find((x) => x.is_other)?.option;

				return (
					<Form.Item
						name={newNamePath}
						rules={[
							{
								required: required ? true : false,
								message: "This field is required!",
							},
						]}
					>
						<Radio.Group size="large">
							<Flex vertical="vertical">
								{form_question_options.filter((x) => !x.is_other).length
									? form_question_options.map((item, index) => {
											return (
												<Radio key={`${item.id}-${index}`} value={item.option}>
													<Flex align="baseline" gap={5}>
														{item.option}
														{item.is_other && selectedValue === findOther ? (
															<Form.Item name={`${newNamePath}_other`} noStyle>
																<Input placeholder="Please specify" />
															</Form.Item>
														) : null}
													</Flex>
												</Radio>
											);
									  })
									: null}
							</Flex>
						</Radio.Group>
					</Form.Item>
				);
			}}
		</Form.Item>
	);
}
